import React, { MouseEventHandler, useCallback, useState } from 'react';
import { Button, ButtonProps } from '@cp/ds/src/components/button';
import { User } from '@cp/entities/user';
import { ClientType } from '@common/model/client/clientType';
import { Tooltip } from '@cp/ds/src/components/tooltip';
import { getActionErrorMessage, getUserFromInteraction, useInteractionDetails } from '../model';

export interface ActivateSubjectButtonProps extends ButtonProps {
  interactionId: number;
  connectAs?: ClientType;
  activateSubject: (p: { id: number; asClient: User | null }) => PromiseLike<void>;
}

export const ActivateSubjectButton = ({ interactionId, connectAs, activateSubject, ...props }: ActivateSubjectButtonProps) => {
  const { loadDetails, isLoading } = useInteractionDetails(interactionId);
  const [title, setTitle] = useState('');

  const onClick: MouseEventHandler<HTMLButtonElement> = useCallback(
    async (e) => {
      e.stopPropagation();
      const detailsResult = await loadDetails();
      if (detailsResult.isErr) {
        setTitle(getActionErrorMessage(detailsResult.error));
        return;
      }
      const details = detailsResult.unwrap();
      const asClient = connectAs ? getUserFromInteraction(connectAs, details) : null;
      if (connectAs && asClient === null) {
        setTitle('Невозможно подключиться к диалогу');
        return;
      }
      try {
        await activateSubject({ id: details.subjectId, asClient });
        setTitle('');
      } catch (error) {
        setTitle(getActionErrorMessage(error instanceof Error ? error : undefined));
      }
    },
    [loadDetails, connectAs, activateSubject],
  );

  return (
    <Tooltip arrow colorSchema="error" title={title}>
      <Button disabled={isLoading} onClick={onClick} {...props} />
    </Tooltip>
  );
};
